module.exports = __webpack_public_path__ + "img/down-time-analysis.1c1f7b7c.svg";